import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=4d47fb32"
import script from "./PageLayout.ts?vue&type=script&lang=ts&external"
export * from "./PageLayout.ts?vue&type=script&lang=ts&external"
import style0 from "./PageLayout.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports